/**
 * Created by agengmaulana on 4/25/17.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Comment_Article_Master from './src/component/comment_article/comment_article_master'
import Comment_Form from './src/component/comment_form/comment_form'
import Comment_Dropdown_Box from './src/component/comment_dropdown_box/comment_dropdown_box'
import Comment_Count from './src/component/comment_count/comment_count'
import Comment_Moderation from './src/component/comment_moderation/comment_moderation'
import Comment_Master_Row from './src/component/comment_row/comment_master_row'
import Comment_Pagination from  './src/component/comment_pagination/comment_pagination'
import Prokontra_comment_row from  './src/component/prokontra_comment_row/prokontra_comment_row'
import Prokontra_comment_moderation from  './src/component/prokontra_comment_moderation/prokontra_comment_moderation'
import {observer} from 'mobx-react';
import {observable} from 'mobx'

import styles from './src/assets/css/prokontra_comment.css'
import Prokontra_Comment_Form from "./src/component/prokontra_comment_form/prokontra_comment_form";

@observer
class Prokontra extends React.Component {


    // @observable set_label = ''

    constructor(props) {
        super(props);
        this.state = {firstLoadVerifiy:true};
    }
    render(){
        const {dataStore,isMobile,setlabel_awal} = this.props;
        const datastoresVerified = dataStore.datastoresVerified

        if(dataStore.datastoresModeration.length === 0)
        {
            var moderation = ''
        }
        else {
            moderation = dataStore.datastoresModeration.map(data=>

                <Prokontra_comment_moderation key={data.id} dataStore={data} datastoresVerified={datastoresVerified}/>
            )
        }
        return(
            <div className={styles.pk_area}>

                <Prokontra_Comment_Form sendTo="1" setlabel_awal={setlabel_awal} isMobile={isMobile} dataStore={dataStore}/>
                {moderation}
                <Prokontra_comment_row dataStore={dataStore} datastoresVerified={datastoresVerified}/>

                { dataStore.paging.item > 10 ? <center><Comment_Pagination dataStore={dataStore}/></center> : ' ' }
            </div>

            )
    }
    componentDidUpdate(prevProps) {
        if(this.props.dataStore.getDataVerifiedId.length > 0){ //delay props
            if(this.state.firstLoadVerifiy){
                var dataVerifiedId = this.props.dataStore.getDataVerifiedId.map(function(data){return data})
                var distinct = this.props.dataStore.distincArray(dataVerifiedId)
                this.props.dataStore.fetchDataVerifiedUser(distinct)
                this.setState({firstLoadVerifiy:false}) //false
            }
        }
    }
}


var PK
PK = Prokontra

module.exports = PK;



// WEBPACK FOOTER //
// ./static/prokontra.js